import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useLocation, useNavigate } from "react-router-dom";
import { assetSendFeedbackAxios } from "../../Actions/axios";
import { isEmpty } from "../../Actions/common";
import { toast } from "react-toastify";

const AssetFeedback = () => {
  const location = useLocation();

  const navigate = useNavigate();
  const [data, setData] = useState({
    subject: "",
  });
  const [content, setContent] = useState("");
  console.log("🚀 ~ AssetFeedback ~ data:", data);
  const [err, setErr] = useState({});

  const onChangeData = (e) => {
    const { value, name } = e.target;
    if (name == "content") {
      setContent(value);
      return true
    }
    setData({ ...data, [name]: value });
  };

  const validataion = async () => {
    let err = {};
    let allData = { ...data, content };
    console.log("🚀 ~ validataion ~ allData:", allData)
    await Promise.all(
      Object.keys(allData)?.map((val) => {
        if (isEmpty(allData[val])) {
          err[val] = `${val} is required`;
        }
      })
    );
    setErr(err);
    return err;
  };

  const sendFeedback = async () => {
    let err = await validataion();
    console.log("🚀 ~ sendFeedback ~ err:", err);
    if (!isEmpty(err)) {
      return toast.error("Field Required");
    }
    let resp = await assetSendFeedbackAxios({ ...data, content });
    console.log("🚀 ~ sendFeedback ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/assetlist");
    } else {
      toast.error(resp?.message);
    }
  };

  useEffect(() => {
    setData({ ...data, assetId: location?.state?._id });
  }, [location]);
  return (
    <div className="cmsadd">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>
      <h1 className="pagehead">Asset Add</h1>
      <div className="cardbox">
        <Form>
          <Row>
            <Col xs={12} sm={12} md={6} lg={6} className="mb-4">
              <Form.Group>
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  onChange={onChangeData}
                />
                {err.subject && <p>{err?.subject}</p>}
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group className="mb-4">
                <Form.Label>Content</Form.Label>
                <SunEditor
                  onChange={(e) =>
                    onChangeData({ target: { name: "content", value: e } })
                  }
                  height={300}
                />
                {err?.content && <p>{err?.content}</p>}
              </Form.Group>
            </Col>
          </Row>
        </Form>
        <button
          type="button"
          onClick={sendFeedback}
          className="btn sitebtn py-2 px-3"
        >
          Add
        </button>
      </div>
    </div>
  );
};

export default AssetFeedback;
